import { ValidationErrorData } from '../typings/common';
import { CurrencyCode, GdViewType } from '../typings/graphql-grid';
import { EditPricePackageErrorsRecord, PricePackageEditData, PricePackageId } from '../typings/pricePackages';
import { RegionsEditorData } from '../typings/regionsEditor';

export const GET_PRICE_PACKAGES_FOR_EDIT = 'GET_PRICE_PACKAGES_FOR_EDIT';
export type GET_PRICE_PACKAGES_FOR_EDIT = typeof GET_PRICE_PACKAGES_FOR_EDIT;

export interface GetPricePackagesForEditAction {
    type: GET_PRICE_PACKAGES_FOR_EDIT;
}

export function getPricePackagesForEdit(): GetPricePackagesForEditAction {
    return {
        type: GET_PRICE_PACKAGES_FOR_EDIT
    };
}

export const GET_PRICE_PACKAGE_DATA_FOR_CREATION = 'GET_PRICE_PACKAGE_DATA_FOR_CREATION';
export type GET_PRICE_PACKAGE_DATA_FOR_CREATION = typeof GET_PRICE_PACKAGE_DATA_FOR_CREATION;

export interface GetPricePackageDataForCreationAction {
    type: GET_PRICE_PACKAGE_DATA_FOR_CREATION;
}

export function getPricePackageDataForCreation(): GetPricePackageDataForCreationAction {
    return {
        type: GET_PRICE_PACKAGE_DATA_FOR_CREATION
    };
}

export const UPDATE_PRICE_PACKAGES_DATA_FOR_EDIT = 'UPDATE_PRICE_PACKAGES_DATA_FOR_EDIT';
export type UPDATE_PRICE_PACKAGES_DATA_FOR_EDIT = typeof UPDATE_PRICE_PACKAGES_DATA_FOR_EDIT;

export interface UpdatePricePackagesDataForEditAction {
    type: UPDATE_PRICE_PACKAGES_DATA_FOR_EDIT;
    pricePackages: Record<PricePackageId, PricePackageEditData>;
}

export function updatePricePackagesDataForEdit(
    pricePackages: Record<PricePackageId, PricePackageEditData>
): UpdatePricePackagesDataForEditAction {
    return {
        type: UPDATE_PRICE_PACKAGES_DATA_FOR_EDIT,
        pricePackages
    };
}

export const CANCEL_PRICE_PACKAGE_EDITOR_REGIONS = 'CANCEL_PRICE_PACKAGE_EDITOR_REGIONS';
export type CANCEL_PRICE_PACKAGE_EDITOR_REGIONS = typeof CANCEL_PRICE_PACKAGE_EDITOR_REGIONS;

export interface CancelPricePackageEditorRegionsAction {
    type: CANCEL_PRICE_PACKAGE_EDITOR_REGIONS;
    pricePackageId: PricePackageId;
    selectedMap: Record<number, boolean>;
}

export function cancelPricePackageEditorRegions(
    pricePackageId: PricePackageId,
    selectedMap: Record<number, boolean>
): CancelPricePackageEditorRegionsAction {
    return {
        type: CANCEL_PRICE_PACKAGE_EDITOR_REGIONS,
        pricePackageId,
        selectedMap
    };
}

export const SAVE_PRICE_PACKAGE_EDITOR_REGIONS = 'SAVE_PRICE_PACKAGE_EDITOR_REGIONS';
export type SAVE_PRICE_PACKAGE_EDITOR_REGIONS = typeof SAVE_PRICE_PACKAGE_EDITOR_REGIONS;

export interface SavePricePackageEditorRegionsAction {
    type: SAVE_PRICE_PACKAGE_EDITOR_REGIONS;
    data: RegionsEditorData;
}

export function savePricePackageEditorRegions(data: RegionsEditorData): SavePricePackageEditorRegionsAction {
    return {
        type: SAVE_PRICE_PACKAGE_EDITOR_REGIONS,
        data
    };
}

export const UPDATE_PRICE_PACKAGE_EDITOR_REGIONS = 'UPDATE_PRICE_PACKAGE_EDITOR_REGIONS';
export type UPDATE_PRICE_PACKAGE_EDITOR_REGIONS = typeof UPDATE_PRICE_PACKAGE_EDITOR_REGIONS;

export interface UpdatePricePackageEditorRegionsAction {
    type: UPDATE_PRICE_PACKAGE_EDITOR_REGIONS;
    data: RegionsEditorData;
}

export function updatePricePackageEditorRegions(data: RegionsEditorData): UpdatePricePackageEditorRegionsAction {
    return {
        type: UPDATE_PRICE_PACKAGE_EDITOR_REGIONS,
        data
    };
}

// EDITORS ACTIONS
export const SAVE_PRICE_PACKAGE_EDITOR_NAME = 'SAVE_PRICE_PACKAGE_EDITOR_NAME';
export type SAVE_PRICE_PACKAGE_EDITOR_NAME = typeof SAVE_PRICE_PACKAGE_EDITOR_NAME;

export interface SavePricePackageEditorNameAction {
    type: SAVE_PRICE_PACKAGE_EDITOR_NAME;
    pricePackageId: PricePackageId;
}

export function savePricePackageEditorName(pricePackageId: PricePackageId): SavePricePackageEditorNameAction {
    return {
        type: SAVE_PRICE_PACKAGE_EDITOR_NAME,
        pricePackageId
    };
}

export const UPDATE_PRICE_PACKAGE_NAME = 'UPDATE_PRICE_PACKAGE_NAME';
export type UPDATE_PRICE_PACKAGE_NAME = typeof UPDATE_PRICE_PACKAGE_NAME;

export interface UpdatePricePackageNameAction {
    type: UPDATE_PRICE_PACKAGE_NAME;
    pricePackageId: PricePackageId;
    name: string;
}

export function updatePricePackageName(pricePackageId: PricePackageId, name: string): UpdatePricePackageNameAction {
    return {
        type: UPDATE_PRICE_PACKAGE_NAME,
        pricePackageId,
        name
    };
}

export const UPDATE_PRICE_PACKAGE_MIN_SHOWS = 'UPDATE_PRICE_PACKAGE_MIN_SHOWS';
export type UPDATE_PRICE_PACKAGE_MIN_SHOWS = typeof UPDATE_PRICE_PACKAGE_MIN_SHOWS;

export interface UpdatePricePackageMinShowsAction {
    type: UPDATE_PRICE_PACKAGE_MIN_SHOWS;
    pricePackageId: PricePackageId;
    value: number;
}

export function updatePricePackageMinShows(
    pricePackageId: PricePackageId,
    value: number
): UpdatePricePackageMinShowsAction {
    return {
        type: UPDATE_PRICE_PACKAGE_MIN_SHOWS,
        pricePackageId,
        value
    };
}

export const UPDATE_PRICE_PACKAGE_MAX_SHOWS = 'UPDATE_PRICE_PACKAGE_MAX_SHOWS';
export type UPDATE_PRICE_PACKAGE_MAX_SHOWS = typeof UPDATE_PRICE_PACKAGE_MAX_SHOWS;

export interface UpdatePricePackageMaxShowsAction {
    type: UPDATE_PRICE_PACKAGE_MAX_SHOWS;
    pricePackageId: PricePackageId;
    value: number;
}

export function updatePricePackageMaxShows(
    pricePackageId: PricePackageId,
    value: number
): UpdatePricePackageMaxShowsAction {
    return {
        type: UPDATE_PRICE_PACKAGE_MAX_SHOWS,
        pricePackageId,
        value
    };
}

export const UPDATE_PRICE_PACKAGE_PRICE = 'UPDATE_PRICE_PACKAGE_PRICE';
export type UPDATE_PRICE_PACKAGE_PRICE = typeof UPDATE_PRICE_PACKAGE_PRICE;

export interface UpdatePricePackagePriceAction {
    type: UPDATE_PRICE_PACKAGE_PRICE;
    pricePackageId: PricePackageId;
    value: number;
}

export function updatePricePackagePrice(pricePackageId: PricePackageId, value: number): UpdatePricePackagePriceAction {
    return {
        type: UPDATE_PRICE_PACKAGE_PRICE,
        pricePackageId,
        value
    };
}

export const UPDATE_PRICE_PACKAGE_CURRENCY = 'UPDATE_PRICE_PACKAGE_CURRENCY';
export type UPDATE_PRICE_PACKAGE_CURRENCY = typeof UPDATE_PRICE_PACKAGE_CURRENCY;

export interface UpdatePricePackageCurrencyAction {
    type: UPDATE_PRICE_PACKAGE_CURRENCY;
    pricePackageId: PricePackageId;
    currency: CurrencyCode;
}

export function updatePricePackageCurrency(
    pricePackageId: PricePackageId,
    currency: CurrencyCode
): UpdatePricePackageCurrencyAction {
    return {
        type: UPDATE_PRICE_PACKAGE_CURRENCY,
        pricePackageId,
        currency
    };
}

export const UPDATE_PRICE_PACKAGE_VIEW_TYPE = 'UPDATE_PRICE_PACKAGE_VIEW_TYPE';
export type UPDATE_PRICE_PACKAGE_VIEW_TYPE = typeof UPDATE_PRICE_PACKAGE_VIEW_TYPE;

export interface UpdatePricePackageViewTypeAction {
    type: UPDATE_PRICE_PACKAGE_VIEW_TYPE;
    pricePackageId: PricePackageId;
    checked: boolean;
    viewType: GdViewType;
}

export function updatePricePackageViewType(
    pricePackageId: PricePackageId,
    checked: boolean,
    viewType: GdViewType
): UpdatePricePackageViewTypeAction {
    return {
        type: UPDATE_PRICE_PACKAGE_VIEW_TYPE,
        pricePackageId,
        checked,
        viewType
    };
}

export const UPDATE_PRICE_PACKAGE_BEHAVIORS = 'UPDATE_PRICE_PACKAGE_BEHAVIORS';
export type UPDATE_PRICE_PACKAGE_BEHAVIORS = typeof UPDATE_PRICE_PACKAGE_BEHAVIORS;

export interface UpdatePricePackageBehaviorsAction {
    type: UPDATE_PRICE_PACKAGE_BEHAVIORS;
    pricePackageId: PricePackageId;
    checked: boolean;
}

export function updatePricePackageBehaviors(
    pricePackageId: PricePackageId,
    checked: boolean
): UpdatePricePackageBehaviorsAction {
    return {
        type: UPDATE_PRICE_PACKAGE_BEHAVIORS,
        pricePackageId,
        checked
    };
}

export const UPDATE_PRICE_PACKAGE_TICKET = 'UPDATE_PRICE_PACKAGE_TICKET';
export type UPDATE_PRICE_PACKAGE_TICKET = typeof UPDATE_PRICE_PACKAGE_TICKET;

export interface UpdatePricePackageTicketAction {
    type: UPDATE_PRICE_PACKAGE_TICKET;
    pricePackageId: PricePackageId;
    value: string;
}

export function updatePricePackageTicket(
    pricePackageId: PricePackageId,
    value: string
): UpdatePricePackageTicketAction {
    return {
        type: UPDATE_PRICE_PACKAGE_TICKET,
        pricePackageId,
        value
    };
}

export const SAVE_PRICE_PACKAGES = 'SAVE_PRICE_PACKAGES';
export type SAVE_PRICE_PACKAGES = typeof SAVE_PRICE_PACKAGES;

export interface SavePricePackagesAction {
    type: SAVE_PRICE_PACKAGES;
}

export function savePricePackages(): SavePricePackagesAction {
    return {
        type: SAVE_PRICE_PACKAGES
    };
}

export const LEAVE_PRICE_PACKAGES_EDIT = 'LEAVE_PRICE_PACKAGES_EDIT';
export type LEAVE_PRICE_PACKAGES_EDIT = typeof LEAVE_PRICE_PACKAGES_EDIT;

export interface LeavePricePackagesEditAction {
    type: LEAVE_PRICE_PACKAGES_EDIT;
}

export function leavePricePackagesEdit(): LeavePricePackagesEditAction {
    return {
        type: LEAVE_PRICE_PACKAGES_EDIT
    };
}

export const SHOW_PRICE_PACKAGE_EDIT_ERRORS = 'SHOW_PRICE_PACKAGE_EDIT_ERRORS';
export type SHOW_PRICE_PACKAGE_EDIT_ERRORS = typeof SHOW_PRICE_PACKAGE_EDIT_ERRORS;

export interface ShowPricePackageEditErrorsAction {
    type: SHOW_PRICE_PACKAGE_EDIT_ERRORS;
    errors: EditPricePackageErrorsRecord;
}

export function showPricePackageEditErrors(errors: EditPricePackageErrorsRecord): ShowPricePackageEditErrorsAction {
    return {
        type: SHOW_PRICE_PACKAGE_EDIT_ERRORS,
        errors
    };
}

export const SHOW_COMMON_PRICE_PACKAGE_SAVE_ERRORS = 'SHOW_COMMON_PRICE_PACKAGE_SAVE_ERRORS';
export type SHOW_COMMON_PRICE_PACKAGE_SAVE_ERRORS = typeof SHOW_COMMON_PRICE_PACKAGE_SAVE_ERRORS;

export interface ShowCommonPricePackageSaveErrorAction {
    type: SHOW_COMMON_PRICE_PACKAGE_SAVE_ERRORS;
    errors: ValidationErrorData[];
}

export function showCommonPricePackageSaveError(errors: ValidationErrorData[]): ShowCommonPricePackageSaveErrorAction {
    return {
        type: SHOW_COMMON_PRICE_PACKAGE_SAVE_ERRORS,
        errors
    };
}

export const CHANGE_TARGETING_IN_PRICE_PACKAGE = 'CHANGE_TARGETING_IN_PRICE_PACKAGE';
export type CHANGE_TARGETING_IN_PRICE_PACKAGE = typeof CHANGE_TARGETING_IN_PRICE_PACKAGE;

export interface ChangeTargetingInPricePackageAction {
    type: CHANGE_TARGETING_IN_PRICE_PACKAGE;
    id: string;
    isFixed: boolean;
}

export function changeTargetingInPricePackageAction(id: string, isFixed: boolean): ChangeTargetingInPricePackageAction {
    return {
        type: CHANGE_TARGETING_IN_PRICE_PACKAGE,
        id,
        isFixed
    };
}

export const CLEAR_ERRORS_GEO_IN_PRICE_PACKAGE = 'CLEAR_ERRORS_GEO_IN_PRICE_PACKAGE';
export type CLEAR_ERRORS_GEO_IN_PRICE_PACKAGE = typeof CLEAR_ERRORS_GEO_IN_PRICE_PACKAGE;

export interface ClearErrorsGeoInPricePackageAction {
    type: CLEAR_ERRORS_GEO_IN_PRICE_PACKAGE;
    id: string;
}

export function clearErrorsGeoInPricePackageAction(id: string): ClearErrorsGeoInPricePackageAction {
    return {
        type: CLEAR_ERRORS_GEO_IN_PRICE_PACKAGE,
        id
    };
}

export type PricePackagesEditAction =
    | ShowCommonPricePackageSaveErrorAction
    | ShowPricePackageEditErrorsAction
    | CancelPricePackageEditorRegionsAction
    | SavePricePackageEditorRegionsAction
    | UpdatePricePackageEditorRegionsAction
    | GetPricePackagesForEditAction
    | GetPricePackageDataForCreationAction
    | UpdatePricePackagesDataForEditAction
    | SavePricePackageEditorNameAction
    | UpdatePricePackageNameAction
    | UpdatePricePackageMinShowsAction
    | UpdatePricePackageMaxShowsAction
    | UpdatePricePackagePriceAction
    | UpdatePricePackageCurrencyAction
    | UpdatePricePackageViewTypeAction
    | UpdatePricePackageBehaviorsAction
    | UpdatePricePackageTicketAction
    | SavePricePackagesAction
    | LeavePricePackagesEditAction
    | ChangeTargetingInPricePackageAction
    | ClearErrorsGeoInPricePackageAction;
